import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { WorkspaceHeaderDetails } from '../../../projects/gql/generated/WorkspaceHeaderDetails';
import { ProjectNavigationInfo } from '../../../navigation/components/Workspaces/gql/generated/ProjectNavigationInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectsInWorkspaceQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  filter?: Types.InputMaybe<Types.AccountProjectFilter>;
  orders?: Types.InputMaybe<Array<Types.ProjectOrderInput>>;
}>;


export type GetProjectsInWorkspaceQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, workspace?: { __typename?: 'Workspace', id: string, isWorkfront?: boolean | null, name: string, visibleActiveProjectCount?: number | null, visibleInactiveProjectCount?: number | null, projects?: { __typename?: 'ProjectConnection', totalCount: number, nodes: Array<{ __typename?: 'Project', id: string, name: string, workspaceId: string, mountedStorageStatus?: Types.MountedStorageStatus | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null, externallyManagedIntegration?: { __typename?: 'ExternallyManagedIntegration', integration?: Types.Integration | null, canUpdateInternalAssetContentSecurity: boolean, canUpdateWorkspaceName: boolean } | null, images?: { __typename?: 'Images', image128?: string | null, original?: string | null } | null, permissions?: { __typename?: 'WorkspacePermissions', canCreateProject: boolean, canDelete: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean, canUpdate: boolean } | null } | null } | null };


export const GetProjectsInWorkspace = /*#__PURE__*/ gql`
    query GetProjectsInWorkspace($workspaceId: ID!, $page: PageInput!, $filter: AccountProjectFilter, $orders: [ProjectOrderInput!]) {
  account(by: {workspaceId: $workspaceId}) {
    id
    workspace(workspaceId: $workspaceId) {
      id
      ...WorkspaceHeaderDetails
      projects(page: $page, filter: $filter, orders: $orders) {
        nodes {
          ...ProjectNavigationInfo
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    }
  }
}
    ${WorkspaceHeaderDetails}
${ProjectNavigationInfo}` as unknown as DocumentNode<GetProjectsInWorkspaceQuery, GetProjectsInWorkspaceQueryVariables>;

          

          export const useGetProjectsInWorkspaceQuery = (options?:QueryHookOptions<GetProjectsInWorkspaceQuery, GetProjectsInWorkspaceQueryVariables>) => useQuery(GetProjectsInWorkspace, options);

          

          export type GetProjectsInWorkspaceQueryOptions = QueryHookOptions<GetProjectsInWorkspaceQuery, GetProjectsInWorkspaceQueryVariables>;

          

          export const useGetProjectsInWorkspaceLazyQuery = (options?:LazyQueryHookOptions<GetProjectsInWorkspaceQuery, GetProjectsInWorkspaceQueryVariables>) => useLazyQuery(GetProjectsInWorkspace, options);

          

          export type GetProjectsInWorkspaceQueryResult = ReturnType<typeof useGetProjectsInWorkspaceQuery>;

          
